import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Agent } from '../../../types/flzhub';
import { getAgentColor, getAgentInitials, getRoleLabel, Card, Label } from './Shared';
import MertebeBadge from '../../esma/MertebeBadge';
import EsmaRadarChart from '../../esma/EsmaRadarChart';
import GrowthJourney from '../../esma/GrowthJourney';
import HalIndicator from '../../esma/HalIndicator';

interface Props {
  agent: Agent;
}

export const FlzAgentDetail: React.FC<Props> = ({ agent }) => {
  return (
    <div style={{ width: 220, borderLeft: '1px solid var(--os-border)', overflowY: 'auto', padding: 16, background: 'rgba(0,0,0,0.1)', flexShrink: 0 }}>
      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <div style={{ width: 64, height: 64, borderRadius: '50%', background: getAgentColor(agent.agent_name), color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, fontWeight: 800, margin: '0 auto 12px', border: '3px solid rgba(255,255,255,0.1)' }}>
          {getAgentInitials(agent.agent_name)}
        </div>
        <div style={{ fontSize: 14, fontWeight: 800 }}>{agent.agent_name}</div>
        <div style={{ fontSize: 10, color: 'var(--os-muted)', marginTop: 4 }}>{getRoleLabel(agent.id)} · Level {agent.level}</div>
        {agent.mertebe_level && <div style={{ marginTop: 8, display: 'flex', justifyContent: 'center' }}><MertebeBadge mertebe_level={agent.mertebe_level} size="sm" /></div>}
        {agent.tasavvuf_hal && <div style={{ marginTop: 8 }}><HalIndicator hal={agent.tasavvuf_hal} /></div>}
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <Card><Label>Persona</Label><div style={{ fontSize: 10, marginTop: 4, lineHeight: 1.4 }}>{agent.persona}</div></Card>
        <Card><Label>Expertise</Label><div style={{ fontSize: 10, marginTop: 4 }}>{agent.expertise || agent.interest_area}</div></Card>
        
        {agent.esma_profile && (
          <Card>
            <Label>Soul Map</Label>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8 }}>
              <EsmaRadarChart esma_profile={agent.esma_profile} size={140} />
            </div>
          </Card>
        )}
        
        <Card>
          <Label>Growth Yolculuğu</Label>
          <div style={{ marginTop: 8 }}><GrowthJourney agentId={agent.id} /></div>
        </Card>
        
        <button style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #6366f1', background: 'rgba(99,102,241,0.1)', color: '#818cf8', fontSize: 11, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
          <ExternalLink size={14} /> Full Profile
        </button>
      </div>
    </div>
  );
};
